const interpolateTemplate = (
  label: string,
  replacements: Record<string, string>
) => {
  if (!replacements) {
    return label;
  }

  for (const [key, value] of Object.entries(replacements)) {
    label = label.replace(`{${key}}`, value);
  }
  return label;
};

export { interpolateTemplate };
